import React from "react";
import UnityGame from "./Game";

function App() {
  return <UnityGame />;
}

export default App;
